module.exports = __webpack_public_path__ + "static/media/chevrolet.f743fe0a.svg";